import { useScrollAnimation, useCountUp } from '../../../hooks/useScrollAnimation';

const STATS = [
  { target: 500, suffix: '+', label: 'Installations Completed', icon: 'ri-tools-fill' },
  { target: 5, suffix: '.0★', label: 'Google Rating', icon: 'ri-star-fill' },
  { target: 15, suffix: '+', label: 'Years Experience', icon: 'ri-award-fill' },
  { target: 100, suffix: '%', label: 'NAPIT Certified', icon: 'ri-shield-check-fill' },
];

function StatItem({ target, suffix, label, icon, index }: { target: number; suffix: string; label: string; icon: string; index: number }) {
  const { ref, isVisible } = useScrollAnimation();
  const count = useCountUp(target, isVisible);

  return (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      className={`flex flex-col items-center text-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="w-14 h-14 flex items-center justify-center rounded-full border border-[#C8A96A]/30 bg-[#C8A96A]/8 mb-4">
        <i className={`${icon} text-[#C8A96A] text-xl`} />
      </div>
      <div className="font-playfair text-3xl md:text-4xl font-bold mb-1"
        style={{
          backgroundImage: 'linear-gradient(90deg, #C8A96A, #E0C78A)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}
      >
        {count}{suffix}
      </div>
      <p className="text-white/50 text-sm">{label}</p>
    </div>
  );
}

export default function ServiceStats() {
  return (
    <section className="py-16 bg-[#071120] border-b border-[#C8A96A]/10">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {STATS.map((s, i) => (
            <StatItem key={s.label} {...s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
